import { render, staticRenderFns } from "./lack-ticket-chart.vue?vue&type=template&id=28b985a7&"
import script from "./lack-ticket-chart.vue?vue&type=script&lang=js&"
export * from "./lack-ticket-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports